var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:_vm.sizeClass,style:(_vm.rotation)},[_c(_vm.iconFile,{tag:"component",class:_vm.sizeClass,attrs:{"color":_vm.colorComputed,"aria-labelledby":"desc"}},[_c('desc',[_vm._v(_vm._s(_vm.altFinal))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }